const certificationImageData = [
  {
    src: "/assets/images/certifications/certification1.jpg",
    width: 1200,
    height: 800,
    title: "WEIBO ELEVATORS CO.LTD",
    description: "GB/T 45001-2020/ISO 45001:2018 standard",
  },
  {
    src: "/assets/images/certifications/certification2.jpg",
    width: 600,
    height: 900,
    title: "WEIBO ELEVATORS CO.LTD",
    description: "GB/T 24001-2016/ISO 45001:2018 standard",
  },
  {
    src: "/assets/images/certifications/certification3.jpg",
    width: 1920,
    height: 1080,
    title: "WEIBO ELEVATORS CO.LTD",
    description: "GB/T 19001-2016/ISO9001:2015 standard",
  },
  {
    src: "/assets/images/certifications/certification4.jpg",
    width: 1000,
    height: 1500,
    title: "WEIBO ELEVATORS CO.LTD",
    description: "GB/T 24001-2016/ISO14001:2015 standard",
  },
];

export default certificationImageData;
